import React from 'react';
import type { EventListItem } from '../types';
import { EventItem } from './EventItem';
import './EventList.css';

interface EventListProps {
  events: EventListItem[];
}

/**
 * EventList component displays EC2 events in chronological order (newest first)
 * Requirements: 4.1, 4.2, 4.3, 4.5
 */
export const EventList: React.FC<EventListProps> = ({ events }) => {
  // Sort events chronologically with newest first
  const sortedEvents = [...events].sort((a, b) => b.receivedAt - a.receivedAt);

  // Display empty state when no events
  if (sortedEvents.length === 0) {
    return (
      <div className="event-list-container">
        <div className="event-list-empty">
          <p>No events received yet</p>
          <p className="event-list-empty-subtitle">
            Waiting for EC2 instance events...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="event-list-container">
      <div className="event-list-scrollable">
        <ul className="event-list">
          {sortedEvents.map((event) => (
            <li key={event.id} className="event-list-item">
              <EventItem event={event} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
